<template>
  <label
    v-if="label"
    class="am3-input-label text-primary font-medium text-sm mb-1.5 flex items-center"
    :for="inputId"
  >
    {{ label }}
    <span v-if="required">*</span>
    <slot name="label" />
  </label>
</template>

<script setup>
const props = defineProps({
  // v-model value
  label: {
    type: [String, Boolean],
    default: false,
  },
  required: {
    type: Boolean,
    default: false,
  },
  inputId: {
    type: [String, Boolean],
    default: false,
  },
})
</script>
